import React from 'react';
import Typography from "@mui/material/Typography";
import { StyledFeedbackButton } from './FeedbackButton.style';
export const FeedbackButton = ({ children, onClick, title, fullWidth, variant }) => (React.createElement(StyledFeedbackButton, { variant: variant, fullWidth: fullWidth, onClick: onClick },
    React.createElement(Typography, { lineHeight: "24px" }, title),
    children));
